enum DesalinationMethod {
	SUBMERGED = 'submerged',
	HOSES = 'hoses'
}

export default DesalinationMethod
